<div class="loader" *ngIf="showLoader">
    <div class="lds-css ng-scope loader-wrapper">
      <div class="lds-flickr">
        <div></div>
        <div></div>
        <div></div>
      </div>
      <style type="text/css">
      </style>
    </div>
  </div>
  